export default "__VITE_ASSET__1d90ccdb__"